import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CommonUiComponentsTextInputModule } from '@cdw-ae/common-ui-components-text-input';
import { CdwTreeModule } from '@cdw-ae/common-ui-components-tree';

import { CdwFilteredTreePickerComponent } from './cdw-filtered-tree-picker/cdw-filtered-tree-picker.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialLibraryModule,
    CdwTreeModule,
    CommonUiComponentsTextInputModule,
    CdwCheckboxModule,
  ],
  declarations: [CdwFilteredTreePickerComponent],
  exports: [CdwFilteredTreePickerComponent],
})
export class CdwFilteredTreePickerModule {}
